<template>
  <aside class="d-none d-md-block bg-gray-100 box-shadow rounded font-condensed position-relative overflow-hidden">
    <overlay-wrapper :show="loading">
      <b-nav vertical class="nav-vertical d-none d-lg-flex" data-test-id="nav-vertical-desktop" :class="{ 'py-5' : loading && !items.length }">
        <template v-for="(itm, i) in items">
          <b-nav-item v-if="isAvailable(itm)"
                      :key="'page_navigation_item_'+i"
                      :href="itm.url"
                      :data-test-id="'nav-page-vertical-item_'+i"
                      :active="itm.active"
                      :disabled="isDisabled(itm)"
          >
            <b-icon v-if="itm.icon && itm.icon !== 'null'" :icon="itm.icon" class="mr-3 mb-0 h3" fixed-width />
            {{ itm.title }}
          </b-nav-item>
        </template>
      </b-nav>
      <div v-if="disabled"
           class="mask disabled"
      />
    </overlay-wrapper>
  </aside>
</template>

<script>
import menuMixin from '@/mixins/menuMixin'

export default {
  mixins: [menuMixin],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    },
    items: {
      type: Array,
      required: true,
      default() { return [] }
    }
  }
}
</script>
